import React from "react";

import { Container, Row, Col, Card } from "reactstrap";

import Slider from "react-slick";

function Sponsor() {
  const settings = {
    // dots: true,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 1500,
    slidesToShow: 4,
    slidesToScroll: 2,
    rows: 3,
    className: "p-10",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          row: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          row: 1,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div
        style={{
          backgroundColor: "#fff",
        }}
        className="section section-with-space"
        data-parallax={true}
      >
        <Container>
          <h1
            className="text-center text-g"
            style={{
              fontSize: "3rem",
            }}
          >
            PAST EDITION PARTNERS
          </h1>

          <Row>
            <Col lg={12} className={"mx-auto"}>
              <Slider {...settings}>
                {sponsorsP.map((s, i) => (
                  <a href={s.link} key={i} style={{ padding: "10px" }}>
                    {/* <h4 className="text-center text-400 text-i pb-2">{s.type}</h4> */}
                    <Card
                      style={{ borderRadius: 0, maxWidth: "350px", boxShadow: "none" }}
                      className="mx-auto"
                    >
                      <img
                        src={require(`assets/sponsors/${s.image}`)}
                        className="mx-auto"
                        alt={s.name}
                        width="100%"
                        style={{ borderRadius: 0 }}
                      />
                    </Card>
                  </a>
                ))}
              </Slider>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Sponsor;
export const sponsorsP = [];

const groupBy = (key) => (array) =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

const groupByType = groupBy("type");
export const sponsors = groupByType(sponsorsP);
